import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import {
 Col, Modal, InputGroup, Form,
 Collapse, 
} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { FaExclamationCircle } from 'react-icons/fa';
import {
 FaFilePdf, FaRegFileExcel, FaArrowDownShortWide, FaArrowUpWideShort, 
} from 'react-icons/fa6';

import { Button } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import generateOverallAccountPDF from './Print/OverallAccountPdf';
import generateOverallAccountExcel from './Print/OverallAccountExcel';
import { AuthContext } from '../../../context/AuthContext';
// import DeleteConfirmationModal from '../../../DeleteModal';
import { PermissionContext } from '../../../context/PermissionContext';
import { SideBarRefreshContext } from '../../../context/SideBarRefreshContext';
import BookingInfo from './BookingInfo';

const DayBookTable = () => {
  const [dayBook, setDayData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const { apiGlobal, countryid } = useContext(AuthContext);
  const { permissionsAccess } = useContext(PermissionContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext); 
  const [payInfoDetails, setPayInfoDetails] = useState({
    modalShow: false,
    payInfo: null,
  });
  const [bookingInfoDetails, setBookingInfoDetails] = useState({
    show: false,
    bookingInfo: {},
    paxInfo: {},
  });
  const [totalWalletAmout, setTotalWalletAmount] = useState({
    total_credit_amount: '',
    total_debit_amount: '',
  });

  // Search filter states
  const [searchPaymentDate, setSearchPaymentDate] = useState({
    StartDate: new Date(),
    EndDate: new Date(),
  });


  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const fetchDayBookData = async () => {
    const formdata = new FormData();
    formdata.append('from_date', searchPaymentDate.StartDate);
    formdata.append('to_date', searchPaymentDate.EndDate);
    formdata.append('country_id', countryid);
    try {
      const url = await fetch(`${apiGlobal}day_book.php`, {
        method: 'POST',
        body: formdata,
      });
      const data = await url.json();
      console.log(data);
      if (data.status && data.message === 'Success') {
        setDayData(data?.data);
        setTotalWalletAmount({
            total_credit_amount: data?.tot_cr_amount,
            total_debit_amount: data?.tot_dr_amount,
        });
      } else if (data.status && data.message === 'No data found') {
        setDayData([]);
      } else {
        console.error('Something Went Wrong While fetching Day Book data');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDayBookData();
  }, [refresh, 
    sideBarRefresh?.adminPaymentApprovedRefresh,
    searchPaymentDate.StartDate,
    searchPaymentDate.EndDate,
]);







//   const handleSort = (column) => {
//     const newSortOrder = sortColumn 
//     === column && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column
  
//     const sortedData = [...filteredData].sort((a, b) => {
//       if (column === 'pDAte') {
//         return newSortOrder === 'asc'
//           ? new Date(a.payment_date) - new Date(b.payment_date)
//           : new Date(b.payment_date) - new Date(a.payment_date);
//       } if (column === 'sType') {
//         return newSortOrder === 'asc'
//           ? a.staff_type.localeCompare(b.staff_type)
//           : b.staff_type.localeCompare(a.staff_type);
//       } if (column === 'sName') {
//         return newSortOrder === 'asc'
//           ? a.staff_name.localeCompare(b.staff_name)
//           : b.staff_name.localeCompare(a.staff_name);
//       } if (column === 'amount') {
//         const amountA = parseFloat(a.balance); // Convert string balance to number
//         const amountB = parseFloat(b.balance); // Convert string balance to number
  
//         return newSortOrder === 'asc' ? amountA - amountB : amountB - amountA;
//       }
//       return 0;
//     });
  
//     setApprovedData(sortedData);
//     setSortOrder(newSortOrder);
//     setSortColumn(column); // Update the current sorted column
//   };


    // use Effect to add keyframes for the pulse animation
    useEffect(() => {
      // Add keyframes via JavaScript when component mounts
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }, []);
  
  

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4 p-3 d-flex align-items-center flex-wrap"
        style={{
    borderRadius: '8px',
    backgroundColor: '#f8f9fa',
    gap: '10px',
  }}
      >
        <div className="d-flex flex-column me-2" style={{ maxWidth: '160px' }}>
          <label htmlFor="fromDate" className="form-label mb-1">
            From
          </label>
          <Form.Control
            id="fromDate"
            name="fromDate"
            type="date"
            value={searchPaymentDate.StartDate}
            onChange={e => setSearchPaymentDate({
          ...searchPaymentDate,
          StartDate: e.target.value,
        })}
            style={{
        borderRadius: '25px',
        padding: '8px',
        border: '1px solid #ddd',
      }}
          />
        </div>

        <div className="d-flex flex-column me-2" style={{ maxWidth: '160px' }}>
          <label htmlFor="toDate" className="form-label mb-1">
            To
          </label>
          <Form.Control
            id="toDate"
            name="toDate"
            type="date"
            value={searchPaymentDate?.EndDate}
            onChange={e => setSearchPaymentDate({
          ...searchPaymentDate,
          EndDate: e.target.value,
        })}
            style={{
        borderRadius: '25px',
        padding: '8px',
        border: '1px solid #ddd',
      }}
          />
        </div>
        <div style={{
            marginTop: '30px',
        }}
        >
          <Button
            variant="outline-primary"
            style={{
                borderRadius: '25px',
                padding: '8px 16px',
              }}
            onClick={() => generateOverallAccountPDF(dayBook, searchPaymentDate)}
            title="PDF"
          >
            <FaFilePdf />
          </Button>
          
          <Button
            variant="outline-success"
            style={{
                borderRadius: '25px',
                padding: '8px 16px',
              }}
            onClick={() => generateOverallAccountExcel(dayBook, searchPaymentDate)}
            title="Excel"
          >
            <FaRegFileExcel />
          </Button>
        </div>
        

        <div
          className="wallet ms-auto text-end"
          style={{
    padding: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    minWidth: '220px',
  }}
        >
          <h5
            className="mb-2"
            style={{ color: '#198754', fontWeight: '600' }}
          >
            Total Credit: ₹{totalWalletAmout?.total_credit_amount || 0}
          </h5>
          <h5
            className="mb-0"
            style={{ color: '#dc3545', fontWeight: '600' }}
          >
            Total Debit: ₹{totalWalletAmout?.total_debit_amount || 0}
          </h5>
        </div>

      </div>



      <Table
        responsive
        style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <thead className="bg-success" style={{ color: 'white', textAlign: 'center' }}>
          <tr>
            <th># </th>
            <th 
            //   onClick={() => handleSort('pDAte')}
              style={{ cursor: 'pointer' }}
            >Payment Date 
              {/* {sortColumn === 'pDAte' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)} */}
            </th>
            <th
            //   onClick={() => handleSort('sType')}
              style={{ cursor: 'pointer' }}
            >
              Perticular 
              {/* {sortColumn === 'sType' 
              && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)} */}
            </th>
            <th
            //   onClick={() => handleSort('sName')}
              style={{ cursor: 'pointer' }}
            >
              Credit 
              {/* {sortColumn === 'sName' 
              && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)} */}
            </th>
            <th
            //   onClick={() => handleSort('amount')}
              style={{ cursor: 'pointer' }}
            >Debit 
              {/* {sortColumn === 'amount' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)} */}
            </th>
            <th
            //   onClick={() => handleSort('amount')}
              style={{ cursor: 'pointer' }}
            >Balance 
              {/* {sortColumn === 'amount' 
            && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)} */}
            </th>
            <th>Pay Info</th>
            <th>Booking Info</th>
          </tr>
        </thead>
        <tbody>
          {dayBook.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{
                               textAlign: 'center',
                   padding: '50px',
                   backgroundColor: '#f8d7da',
                   borderRadius: '8px',
                   marginTop: '20px',
                               color: '#721c24',
                   fontSize: '16px',
                             }}
                >
                  <div
                    style={{
               fontSize: '48px',
               marginBottom: '20px',
               color: '#e63946',
               animation: 'pulse 1.5s infinite ease-in-out',
               display: 'inline-block',
               }}
                  >
                    <FaExclamationCircle />
                  </div>
                  <p>No day wise report Available</p>
                </div>
                {/* <h3>No Approved Data Available</h3> */}
              </td>
            </tr>
          ) : (
            dayBook.map((report, index) => (
              <tr
                key={report.id}
                style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f2f2f2', textAlign: 'center' }}
              >
                <td>{index + 1}</td>
                <td>{formatDate(report.payment_date)}</td>
                <td>
                  <div>
                    {report.staff_type}-{report.staff_name} <br />
                    <span style={{
                        color: 'red',
                    }}
                    >
                      {report.narration}
                    </span>
                  </div>
                  
                </td>
                <td>{report.cr_amount}</td>
                <td>{report.dr_amount}</td>
                <td>{report.balance}</td>
                <td>
                  {/* eslint-disable-next-line */}
                  <a 
                    style={{
                        cursor: 'pointer',
                        color: 'blue',
                        textDecoration: 'underline',
                    }}
                    onClick={() => {
                        setPayInfoDetails({
                            show: true,
                            payInfo: {
                                paymentDate: formatDate(report?.payment_date),
                                paytype: report?.payment_type,
                                paymentAmount: {
                                    cr_amount: report?.cr_amount,
                                    dr_amount: report?.dr_amount,
                                },
                                narration: report?.narration,
                                refno: report?.ref_no,
                                bank: report?.bank,
                                chequeData: formatDate(report?.ref_date),
                                razorPayInfo: report?.payment_type === '2' ? report?.rpay_details[0] : {},
                            },
                        });
                    }}
                  >
                    View
                  </a>
                </td>
                <td>
                  {report?.booking === '1' ? (
                    // eslint-disable-next-line 
                    <a
                      href="#"
                      style={{
        cursor: 'pointer',
        color: 'blue',
        textDecoration: 'underline',
      }}
                      onClick={(e) => {
        e.preventDefault(); // Prevent jumping to top of the page
        setBookingInfoDetails({
          show: true,
          bookingInfo: report?.booking_details[0],
          paxInfo: report?.booking_details[0]?.pax_details,
        });
      }}
                    >
                      View Booking Info
                    </a>
  ) : (
    'NA'
  )}
                </td>

                
                
              </tr>
            ))
          )}
        </tbody>
        {dayBook.length !== 0 && (
        <tfoot>
          <tr style={{
 backgroundColor: '#d1e7dd', fontWeight: 'bold', textAlign: 'center', borderTop: '2px solid red', 
}}
          >
            <td colSpan="3">Total</td>
            <td>{totalWalletAmout.total_credit_amount}</td>
            <td>{totalWalletAmout.total_debit_amount}</td>
            <td colSpan="3" />
          </tr>
        </tfoot>
        )} 
        
      </Table>
      

      {/* modal for showing pay info */}
      <Modal
        show={payInfoDetails?.show}
        onHide={() => setPayInfoDetails({
            show: false,
            payInfo: {
                paymentDate: '',
                paytype: '',
                paymentAmount: {},
                narration: '',
                refno: '',
                bank: '',
                chequeData: '',
                razorPayInfo: null,
            },
        })}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Pay Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            responsive
            style={{
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
          >
            <thead className="bg-success" style={{ color: 'white', textAlign: 'center' }}>
              <tr>
                <th>#</th>
                <th>Payment Date</th>
                <th>Payment Type</th>
                <th>credit</th>
                <th>Debit</th>
                <th>{payInfoDetails?.payInfo?.paytype !== '2' ? 'Narration' : 'Order ID'}</th>
                <th>{payInfoDetails?.payInfo?.paytype !== '2' ? 'Ref No.' : 'Receipt ID'}</th>
                <th>{payInfoDetails?.payInfo?.paytype !== '2' ? 'Bank Name' : 'Payment ID'}</th>
                {
                    payInfoDetails?.payInfo?.paytype === '5' && (
                    <th>Cheque Date</th>
                    )
                } 
              </tr>
            </thead>
            <tbody style={{ textAlign: 'center' }}>
              <tr>
                <td>1</td>
                <td>{payInfoDetails?.payInfo?.paymentDate}</td>
                <td>
                  {(() => {
                switch (payInfoDetails?.payInfo?.paytype) {
                  case '1':
                    return 'Cash';
                  case '2':
                    return 'RazorPay/Online';
                  case '3':
                    return 'NEFT/RTGS/IMPS';
                  case '4':
                    return 'On Account';
                  case '5':
                    return 'Cheque';
                  default:
                    return 'Unknown Payment Method';
                }
              })()}
                </td>
                <td>{payInfoDetails?.payInfo?.paymentAmount?.cr_amount}</td>
                <td>{payInfoDetails?.payInfo?.paymentAmount?.dr_amount}</td>
                {
                    payInfoDetails?.payInfo?.paytype !== '2' ? <td>{payInfoDetails?.payInfo?.narration || 'NA'}</td> 
                    : <td>{payInfoDetails?.payInfo?.razorPayInfo?.order_id || 'NA'}</td>
                }
                {
                    payInfoDetails?.payInfo?.paytype !== '2' ? <td>{payInfoDetails?.payInfo?.refno || 'NA'}</td>
                    : <td>{payInfoDetails?.payInfo?.razorPayInfo?.receipt_id || 'NA'}</td>
                }
                {
                    payInfoDetails?.payInfo?.paytype !== '2' ? <td>{payInfoDetails?.payInfo?.bank || 'NA'}</td>
                    : <td>{payInfoDetails?.payInfo?.razorPayInfo?.payment_id || 'NA'}</td>
                } 
                {
                    payInfoDetails?.payInfo?.paytype === '5' && (
                    <td>{payInfoDetails?.payInfo?.chequeData || 'NA'}</td>
                    )
                } 
              </tr>
            </tbody>   
          </Table>
        </Modal.Body>
      </Modal>

      {/* modal for showing pay info if booking === '1' */}
      <Modal
        show={bookingInfoDetails?.show}
        onHide={() => setBookingInfoDetails({
            show: false,
            bookingInfo: {},
            paxInfo: null,
        })}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Booking Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Collapse title="Booking Details" className="with-shadow">
            <BookingInfo 
              bookingData={bookingInfoDetails?.bookingInfo}
              paxs={bookingInfoDetails?.paxInfo}
            />
          </Collapse>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DayBookTable;
